export default __webpack_public_path__ + "static/logo-sprite-3346945cc08c9c43a8a2dae9b3ca7127.png";